import { render, staticRenderFns } from "./access-strategy-list.vue?vue&type=template&id=3c8f584c&scoped=true&"
import script from "./access-strategy-list.vue?vue&type=script&lang=js&"
export * from "./access-strategy-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f584c",
  null
  
)

export default component.exports